<template lang="html">
  <div class="card">
    <div @click="collapse" class="card-header d-flex justify-content-between">
      <strong>{{ team.name }}</strong>
      <div class="">
        <svg
          :class="{ 'fc-a-icon--collapse': showTeam }"
          class="fc-a-icon fc-a-icon--size-6 fc-a-icon--stroke"
        >
          <use xlink:href="#icon_next" />
        </svg>
      </div>
    </div>

    <div v-if="showTeam" class="">
      <div class="card-body">
        <h3>
          <span
            class="alert"
            :class="{
              'alert-success': congressFull.length < 10,
              'alert-danger': congressFull.length >= 10
            }"
          >
            Available slots: {{ 10 - congressFull.length }}
          </span>
        </h3>
        <table v-if="congressFull.length" class="table table-striped">
          <thead>
            <th scope="col">Name</th>
            <th scope="col">Chamber</th>
            <th scope="col" class=" d-none d-sm-table-cell">State</th>
            <th scope="col" class=" d-none d-lg-table-cell">District</th>
            <th scope="col" class=" d-none d-lg-table-cell">Party</th>
            <th></th>
          </thead>
          <tbody>
            <tr
              v-for="member in congressFull"
              v-bind:key="member.id"
              :class="{ 'hide-member': hideMember == member.id }"
            >
              <td>
                {{
                  member.common_name != ""
                    ? member.common_name
                    : member.first_name
                }}
                {{ member.last_name }}
              </td>
              <td>{{ member.chamber }}</td>
              <td class=" d-none d-sm-table-cell">
                {{ member.state }}
              </td>
              <td class=" d-none d-lg-table-cell">
                <span v-if="member.district != 0">
                  {{ member.district }}
                </span>
              </td>
              <td class=" d-none d-lg-table-cell">
                <svg
                  :title="member.party"
                  class="fc-a-icon fc-a-icon--size-6"
                  :class="'fc-a-icon--' + member.party.toLowerCase()"
                >
                  <use v-bind:xlink:href="'#icon_' + member.party" />
                </svg>
              </td>
              <td>
                <button
                  v-if="hideMember != member.id"
                  @click="drop(member.id)"
                  class="btn btn-primary btn-sm"
                  type="button"
                  name="button"
                >
                  Drop
                </button>
                <button v-else class="btn btn-primary btn-sm" type="button">
                  Drop
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="congressFull.length < 10" class="card-body">
        <div class="form-group ">
          <label for="draftSearch"><b>Add legislator</b></label>
          <div class="fc-a-search">
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search by name, chamber, and party..."
              name="draftSearch"
              value=""
              class="fc-a-search__input form-control"
            />
            <button
              v-if="showLoader"
              type="button"
              class="btn btn-primary"
              name="button"
            >
              Search
            </button>
            <button
              v-else
              @click="search"
              type="button"
              class="btn btn-primary"
              name="button"
            >
              Search
            </button>
          </div>
          <div class="text-danger">
            {{ message }}
          </div>
        </div>
        <loader v-if="showLoader" v-bind:embeded="true"></loader>
        <ul v-else class="list-group list-group-flush">
          <li
            style="list-style: none"
            class="d-flex align-items-center pb-2"
            v-for="c in searchResults"
            v-bind:key="c.id"
          >
            <button @click="add(c)" class="btn btn-success btn-sm mr-2 ">
              Add +
            </button>
            <span>
              <router-link
                target="_blank"
                :to="{ name: ':member', params: { memberId: c.id } }"
                class="fc-a-link--title"
                >{{ c.common_name != "" ? c.common_name : c.first_name }}
                {{ c.last_name }}</router-link
              >
              - {{ c.chamber }}, {{ c.state }}</span
            >
          </li>
        </ul>
      </div>
      <div v-else class="card-body">
        This team is full.
      </div>
    </div>
  </div>
</template>

<script>
import { getCookie } from "@/utils/cookies.js";
import Loader from "@/views/components/Loader";

export default {
  name: "DraftTeam",
  props: ["team"],
  components: {
    loader: Loader
  },
  data: function() {
    return {
      congressFull: [],
      searchQuery: "",
      searchResults: [],
      showLoader: false,
      hideMember: 0,
      showTeam: false,
      message: ""
    };
  },
  created: function() {
    let app = this;
    let url =
      process.env.VUE_APP_CONGRESS +
      "/api/members/?id__in=" +
      encodeURI(app.team.congress);
    if (app.team.congress.length > 0) {
      app.getMembers(url);
    }
  },
  methods: {
    collapse: function() {
      this.showTeam = this.showTeam == true ? false : true;
    },
    add: function(member) {
      let app = this;
      app.message = "";
      app.showLoader = true;
      const csrftoken = getCookie("csrftoken");
      let form = new URLSearchParams({
        id: member.id,
        chamber: member.chamber
      });
      let status = 0;
      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/teams/${app.team.id}/add/`,
        {
          credentials: "include",
          method: "POST",
          mode: "cors",
          body: form,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      )
        .then(function(response) {
          if (response.status == 200) {
            app.congressFull = app.congressFull.concat([member]);
          }
          status = response.status;
          app.searchResults = [];
          app.searchQuery = "";
          app.showLoader = false;
          return response.json();
        })
        .then(function(response) {
          if (status != 200) {
            app.message = response.errors;
          }
        });
    },
    drop: function(id) {
      let app = this;
      app.hideMember = id;
      const csrftoken = getCookie("csrftoken");
      let form = new URLSearchParams({
        member: id
      });

      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/teams/${app.team.id}/drop/`,
        {
          credentials: "include",
          method: "POST",
          mode: "cors",
          body: form,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-CSRFToken": csrftoken
          }
        }
      ).then(function(response) {
        if (response.status == 200) {
          app.congressFull = app.congressFull.filter(member => member.id != id);
        } else {
          app.hideMember = 0;
        }
      });
    },
    getMembers: function(url) {
      let app = this;
      let status = 0;
      fetch(url)
        .then(function(response) {
          status = response.status;
          return response.json();
        })
        .then(function(json) {
          if (status == 200) {
            app.congressFull = json.results;
          }
        });
    },
    search: function() {
      let app = this;
      app.message = "";
      app.showLoader = true;
      app.searchResults = [];
      let status = 0;
      //get all drafted congress members
      fetch(
        `${process.env.VUE_APP_PLATFORM}/api/leagues/${
          app.$route.params.leagueId
        }/`,
        {
          credentials: "include",
          mode: "cors"
        }
      )
        .then(function(response) {
          status = response.status;
          return response.json();
        })
        .then(function(json) {
          if (status == 200) {
            let teams = json.teams.map(team => team.congress);
            let members = [].concat.apply([], teams);
            app.searchCongress(members);
          }
        });
    },
    searchCongress: function(draftedMembers) {
      let app = this;
      let url = `${
        process.env.VUE_APP_CONGRESS
      }/api/members/?limit=5&offset=0&status=active&search=${encodeURI(
        app.searchQuery
      )}&id__not=${encodeURI(draftedMembers)}`;

      fetch(url)
        .then(function(response) {
          return response.json();
        })
        .then(function(json) {
          if (json.results.length > 0) {
            app.searchResults = json.results;
            app.showLoader = false;
          } else {
            app.message =
              "No available legislators found matching this search query";
          }
          app.showLoader = false;
        });
    }
  }
};
</script>

<style type="scss">
.card-header {
  cursor: pointer;
}
.card-header:hover {
  background-color: rgba(51, 51, 51, 0.1);
}
.hide-member {
  opacity: 0.7;
}
</style>
